import { ETraitsTypes } from 'Shared/types';
import { EProvider } from 'Common/consts';
import { validateColumnsForFinngen } from 'Common/utils';
import { getTableColumns as getBinaryColumnsVLR } from './binary';
import { getTableColumns as getContinuousColumnsVLR, getFinngenTableColumns as getFinnGenContinuousColumnsVLR, } from './continuous';
import { TABLE_COLUMNS_DESCRIPTIONS as UKB_BINARY_COLUMNS_DESCRIPTIONS } from './binaryUKB';
import { TABLE_COLUMNS_DESCRIPTIONS as FINNGEN_BINARY_COLUMNS_DESCRIPTIONS } from './binaryFinngen';
import { TABLE_COLUMNS_DESCRIPTIONS as UKB_CONTINUOUS_COLUMNS_DESCRIPTIONS } from './continuousUKB';
import { TABLE_COLUMNS_DESCRIPTIONS as FINNGEN_CONTINUOUS_COLUMNS_DESCRIPTIONS } from './continuousFinngen';
/**
 * Get table columns
 *
 * @param props - an object with the following fields:
 * - traitsType - Traits type
 * - providerId - Id of provider
 * - referrerData - Referrer data for the variant link
 * - columnsData - Additional data for the variant link
 * - datasetName - The name of selected dataset
 * - hasAncestryData - Boolean value which determines if ancestry data exists
 * @returns formatted table columns
 */
export const getColumns = ({ traitsType, providerId, referrerData, columnsData, datasetName, hasAncestryData, }) => {
    const columnsMapper = {
        [ETraitsTypes.Binary]: {
            [EProvider.FinnGen]: getBinaryColumnsVLR(FINNGEN_BINARY_COLUMNS_DESCRIPTIONS, referrerData, columnsData),
            [EProvider.UKB]: getBinaryColumnsVLR(UKB_BINARY_COLUMNS_DESCRIPTIONS, referrerData, columnsData, hasAncestryData),
        },
        [ETraitsTypes.Continuous]: {
            [EProvider.FinnGen]: getFinnGenContinuousColumnsVLR(FINNGEN_CONTINUOUS_COLUMNS_DESCRIPTIONS, referrerData, columnsData),
            [EProvider.UKB]: getContinuousColumnsVLR(UKB_CONTINUOUS_COLUMNS_DESCRIPTIONS, referrerData, columnsData, hasAncestryData),
        },
    };
    if (providerId === EProvider.FinnGen) {
        return validateColumnsForFinngen(columnsMapper[traitsType][providerId], datasetName);
    }
    return columnsMapper[traitsType][providerId];
};
